import React from 'react'
import classes from "./Description.module.css"

const Description = () => {
    return (
        <div className={classes["description-container"]}>
            <div className={classes.description}>
                <header>
                    <h1>Websites for photographers</h1>
                    <h3>EASY, CUSTOMIZABLE TEMPLATES WITH EVERYTHING INCLUDED.</h3>
                    <p>PhotoBiz is built for photographers and includes everything you need to run your studio online. Our designer-made templates are completely customizable with drag {"&" } drop design and flexible layouts. All designs are included with your membership, and you can change your template at any time. Take a look at some of our most recent templates available on PhotoBiz 8.</p>
                </header>

                
            </div>
        </div>
    )
}

export default Description
